export interface RandomRange {
  min: number;
  max: number;
}

export const randomBetween = ({ min, max }: RandomRange) => min + Math.random() * (max - min);
